// extracted by mini-css-extract-plugin
module.exports = {"TipContainer":"style_TipContainer__2sby4","ShareIndicator":"style_ShareIndicator__2WEum","Tips":"style_Tips__3PG4E","TipContainerVisible":"style_TipContainerVisible__1DZ_y"};